export const sifrarnici = {
	map_layer_types: {
    OSM: "OSM",
    Stamen: "STAMEN",
    WMS: "WMS",
    GeoServer: "GEOSERVER",
    Group: "GROUP"
  },
}